module.exports = __webpack_public_path__ + "939976c59a8f2c3ae949d5655ab97bba.png";